import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuTrigger,
} from "@shadcn-in-nx/ui/dropdown-menu";
import { Button } from "@shadcn-in-nx/ui/button";
import { useTranslation } from "react-i18next";
import Ellipsis from "lucide-react/dist/esm/icons/ellipsis";
import { AlertTriangle } from "lucide-react";

const HIGH_COST_THRESHOLD = 20;

function formatCredits(cost) {
    if (cost == null) return null;
    return cost < 0.01 ? cost.toFixed(4) : cost.toFixed(2);
}

function cleanModel(model) {
    if (!model) return null;
    return model.replace(/^us\.anthropic\./, "");
}

export default function MessageUsageDropdown({
    creditsUsed,
    llmModel,
}) {
    const { t } = useTranslation();
    const displayModel = cleanModel(llmModel);
    const hasData = creditsUsed != null || displayModel;
    if (!hasData) return null;

    const isHighCost = creditsUsed != null && creditsUsed >= HIGH_COST_THRESHOLD;

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button variant="ghost" className={`h-6 p-0 ${isHighCost ? "opacity-70 hover:opacity-100" : "opacity-40 hover:opacity-100"}`}>
                    <div className="flex items-center gap-0.5">
                        {isHighCost && <AlertTriangle className="h-3 w-3 text-amber-500" />}
                        <Ellipsis className={`h-4 w-4 ${isHighCost ? "text-amber-500" : ""}`} />
                    </div>
                    <span className="sr-only">{t("chatMessages.messageUsage")}</span>
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="start" className="w-[200px] p-2">
                <div className="space-y-1 text-xs">
                    {creditsUsed != null && (
                        <div className="flex justify-between">
                            <span className="text-gray-400">{t("chatMessages.credits")}</span>
                            <span className={`font-medium ${isHighCost ? "text-amber-600" : "text-gray-700"}`}>
                                {formatCredits(creditsUsed)}
                            </span>
                        </div>
                    )}
                    {displayModel && (
                        <div className="flex justify-between">
                            <span className="text-gray-400">{t("chatMessages.model")}</span>
                            <span className="font-medium text-gray-700 truncate max-w-[100px]">{displayModel}</span>
                        </div>
                    )}
                    {isHighCost && (
                        <p className="text-amber-600 text-[10px] pt-1 border-t border-amber-100">
                            {t("chatMessages.highCostWarning")}
                        </p>
                    )}
                </div>
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
